export default import.meta.ROLLDOWN_FILE_URL_IeYt3gabA5Fp77wsKID3Ew